import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';

export let deleteConnectedAccount = mutatorAction('deleteConnectedAccount', (selected: number) => {
    let store = connectedAccountsStore();
    let accounts = [];
    let index = 0;

    for (index = 0; index < store.accounts.length; index++) {
        if (index !== selected) {
            accounts.push(store.accounts[index]);
        }
    }

    store.accounts = accounts;
    store.selected = -1;
});
